import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Home from './views/Home';
import Support from './views/Support';
import Contact from './views/Contact';
import Privacy from './views/Privacy';
import Terms from './views/Terms';
import Report from './views/Report';

import Header from './components/Header';

import './App.css';


const Component = () => (
  <div className="App">
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="description" content="Get ideas for simple things you can do to live more sustainably. We get you started through weekly sustainable actions sent via SMS message." />
      <title>Baloo: weekly sustainable actions for your community</title>
    </Helmet>
    <Header />
    <Switch>
      <Route path="/contribute" component={Support} />
      <Route path="/contact-us" component={Contact} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/report/:token" component={Report} />
      <Route path="/terms" component={Terms} />
      <Route path="/" component={Home} />
    </Switch>
  </div>
);

Component.displayName = 'App';

export default Component;



// WEBPACK FOOTER //
// ./src/App.js